<template>
  <div>
    <div v-if="!dataLoaded">
      <b-card title="لیست تیکت ها">
        <b-skeleton type="button"></b-skeleton>
        <div class="mt-3">
          <b-skeleton-table
            :rows="10"
            :columns="5"
            :table-props="{ bordered: true, striped: true }"
          ></b-skeleton-table>
        </div>
      </b-card>
    </div>
    <div v-if="dataLoaded">
      <b-card title="لیست تیکت ها">
        <b-button class="mr-3" variant="success" @click="addNewTicket()"
          >تیکت جدید</b-button
        >

        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="ticketList"
        >
          <template v-slot:cell(details)="row">
            <router-link :to="'ticketDetails/' + row.item.id">جزییات</router-link>
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "jalali-moment";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import persianDate from "../../helpers/persianDate";

export default {
  name: "tickets",
  data: function () {
    return {
      dataLoaded: false,
      ticketList: [],
      fields: [
        {
          key: "id",
          label: "شماره تیکت",
        },
        {
          key: "subject",
          label: "عنوان",
        },
        {
          key: "time",
          label: "زمان",
        },
        {
          key: "created_at",
          label: "تاریخ",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "department_name",
          label: "دپارتمان",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
    };
  },
  created() {
    httpHelpoer.setAuth();
    httpHelpoer
      .getData("tickets")
      .then((res) => {
        this.ticketList = res.result.data;
        this.ticketList = this.ticketList.map((item) => {
          return {
            id: item.id,
            subject: item.subject,
            status: item.ticket_status.title,
            created_at: persianDate.getDate(item.created_at),
            time: persianDate.getTime(item.created_at),
            department_name : item.ticket_departments.name
            /*moment(item.created_at, 'YYYY-MM-DDTHH:mm:ss.ZZ').locale('fa').format('YYYY/MM/DD')*/
          };
        });
        this.dataLoaded = true;
      })
      .finally(() => {});

    /*     httpHelpoer
                     .postData("tickets",    {
                         "subject":"new ticket create1",
                         "department_id":2,
                         "mdid1_status":1,
                         "mdid2_periority":1,
                         "text":"ticket text"
                     })
                     .then(res => {
                         console.log(res);

                     })
                     .finally(() => {

                     });*/
  },
  methods: {
    addNewTicket: function () {
      this.$router.push({ name: "addTicket" });
    },
    refreshMenu(){
      this.$root.$emit('refresh_menu', ['asdasd'])
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تیکت ها" }]);
  },
};
</script>